import { useMutation } from '@tanstack/react-query';

import { AddFunnelData, Funnel } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const addFunnel = (data: AddFunnelData): Promise<{ funnel: Funnel }> => {
  return axios.post(`/funnel`, data);
};

type AddFunnelOptions = {
  pageId: string;
  onSuccess: () => void;
  config?: MutationConfig<typeof addFunnel>;
};

export function useAddFunnel({ config = {}, pageId, onSuccess }: AddFunnelOptions) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['funnels', pageId]);
      onSuccess();
    },
    ...config,
    mutationFn: addFunnel,
  });
}
